
























































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as service from '@/services/therapy';
import BaseComponent from '@/components/base-component.vue';
import UiSelectClients from '@/components/UI/select-clients.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import InputMoney from '@/components/UI/input-money.vue';

import { errorHandling } from '@/helpers/errorHandling';
import {
  TerapiaDetalheDTO,
  ProdutoTerapiaDTO,
  TerapiaListItemDTO,
  TipoIdade,
  TerapiaParmDTO,
  ProdutoTerapiaParmDTO,
  IdadePesoQtdeTerapiaDTO,
  VolumeTerapiaParmDTO,
  VolumeTerapiaDTO,
  IdadePesoQtdeTerapiaParmDTO,
} from '../../interfaces/therapy';
import UiAutocompleClientsSubsidiaries from '../UI/autocomplete-clients-subsidiaries.vue';
import { CurrencyDirective, parseCurrency } from 'vue-currency-input';
import { VueMaskDirective } from 'v-mask';
import ListMessages from '../UI/list-messages.vue';
import Unit from '../../views/client-units/screens/index.vue';
import ClientUnitModel from '../../models/client-unit-model';
import IClientUnit from '../../interfaces/clientUnit';
import { isIE, isEdge, browserParser } from '../../helpers/checkBrowser';
import { toNumber } from '@/helpers/toNumber';
import { IdNomeDTO } from '@/interfaces/base-dto';
import { ID_UNIT_ML_DIA } from '@/interfaces/measurement-unit';

@Component({
  components: {
    PermissionAuth,
    UiSelectClients,
    UiAutocompleClientsSubsidiaries,
    ListMessages,
    InputMoney,
  },
  directives: {
    currency: CurrencyDirective,
    mask: VueMaskDirective,
  },
})
export default class TherapyForm extends BaseComponent {
  @Prop()
  public isEdit: boolean;
  @Prop()
  public id: Number;
  @Prop()
  public open: boolean;

  public soProdEscolhidos: boolean = false;

  private loading: boolean = false;
  private loadingProd: boolean = false;
  private error: boolean = false;

  public dto: TerapiaDetalheDTO = new TerapiaDetalheDTO();
  private produtosExibir: any = [];

  private tipoIdadeDias = TipoIdade.D;
  private tipoIdadeAnos = TipoIdade.A;

  private headersProd: any = [{ text: 'Volume / Produtos', value: 'nomeProduto', sortable: false }];
  private prodsSelecionados: any = [];
  private prodSel: any = null;
  private matrizSel: any = null;

  private mapProdMatriz: any = new Map<Number, Array<Array<any>>>();
  private medidasVolume: IdNomeDTO[] = [];

  maskProd = {
    currency: { prefix: '', suffix: '' },
    locale: 'pt-BR',
    precision: { min: 0, max: 2 },
  };

  maskPeso = {
    currency: { prefix: '', suffix: ' kg' },
    locale: 'pt-BR',
    precision: { min: 0, max: 3 },
  };

  getValorSemMask(valor: string, mask) {
    return parseCurrency(valor, mask);
  }

  public form: any = {
    valid: false,
    rules: {
      codigo: [(v) => !!v || 'Informe o Código da Terapia'],
      nome: [(v) => !!v || 'Informe o nome da Terapia'],
      ativo: [(v) => v != null || 'Informe o Status'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  mounted() {
    this.addSubsc(
      service.getTherapyVolumeUnits().subscribe((res) => {
        this.medidasVolume = res;
      }),
    );
  }

  @Watch('open')
  public watchOpen(): void {
    setTimeout(() => {
      if (this.open) {
        if (isIE() || isEdge()) {
          let msg = 'Essa funcionalidade não é apresentada corretamente no ' + browserParser.getBrowserName();
          msg += '<br>Favor utilizar um navegador alternativo. Ex. Chrome e Firefox';
          this.dialog.show('error', 'Atenção', null, 'OK', this.closeAction, null, null, msg, '550');
          return;
        }
        if (this.id) {
          this.buscarTerapia();
        } else {
          this.init();
        }
      }
    }, 500);
  }

  public onCheckProdEscolhidos() {
    if (!this.soProdEscolhidos) {
      this.produtosExibir = this.dto.produtos;
    } else {
      this.produtosExibir = this.dto.produtos.filter(
        (f) => this.isMatrizValorPreenchido(f.idProduto) || f.idProduto == -1,
      );
    }
  }

  private isMatrizValorPreenchido(idProd) {
    let matriz = this.mapProdMatriz[idProd];
    if (!matriz) {
      return false;
    }
    for (let l = 2; l < matriz.length; l++) {
      for (let c = 1; c < matriz[0].length; c++) {
        if (matriz[l][c].valor) {
          return true;
        }
      }
    }
    return false;
  }

  private isProdVolume(prod): boolean {
    return prod.volume;
  }

  private limparMatriz() {
    const limparMatrizAction = () => {
      let matriz = this.matrizSel;
      for (let l = 2; l < matriz.length; l++) {
        for (let c = 1; c < matriz[0].length; c++) {
          matriz[l][c].valor = null;
          this.habilitarProd(matriz, l, c);
        }
      }
      this.ordenarMatriz();
    };

    this.dialog.show(
      'error',
      'Por favor, confirme',
      'Deseja limpar todos os valores preenchidos para ' + this.prodSel.nomeProduto + '?',
      'Cancelar',
      '',
      'Limpar',
      limparMatrizAction,
    );
  }

  public ordenarMatriz() {
    let prod: ProdutoTerapiaDTO = { ...this.prodSel };
    prod.quantidades = new Array();
    let matriz: any = this.matrizSel;
    for (let l = 2; l < matriz.length; l++) {
      for (let c = 1; c < matriz[0].length; c++) {
        let qtde = this.getQuantDTOCel(matriz, l, c, false, this.isProdVolume(this.prodSel));
        if (qtde) {
          prod.quantidades.push(qtde);
        }
      }
    }
    this.matrizSel = this.gerarMatrizProduto(prod);
    this.mapProdMatriz[this.prodSel.idProduto] = this.matrizSel;
  }

  private gerarMatrizProduto(prod): Array<Array<any>> {
    if (!prod.quantidades) {
      prod.quantidades = new Array();
    }

    var idadesAll: any = prod.quantidades.map(function(m) {
      return { idade: m.idade, tipoIdade: m.tipoIdade };
    });
    var idades = new Array();
    idadesAll.forEach((ia) => {
      if (idades.indexOf(idades.filter((i) => i.idade == ia.idade && i.tipoIdade == ia.tipoIdade)[0]) == -1) {
        idades.push(ia);
      }
    });

    idades = idades.sort((o1, o2) => {
      // comparar em dias
      let idade1 = o1.tipoIdade == 'A' ? o1.idade * 365 : o1.idade;
      let idade2 = o2.tipoIdade == 'A' ? o2.idade * 365 : o2.idade;
      if (idade1 < idade2) {
        return -1;
      } else if (idade1 > idade2) {
        return 1;
      } else {
        return 0;
      }
    });

    let pesos: any = new Set(prod.quantidades.map((m) => m.pesoKg));
    pesos = Array.from(pesos);
    pesos = pesos.sort((o1, o2) => {
      if (o1 < o2) {
        return -1;
      } else if (o1 > o2) {
        return 1;
      } else {
        return 0;
      }
    });

    let qtdeColMin = this.isProdVolume(prod) ? 10 : 12;
    let qtdeLinMin = 18;
    let qtdeCols = pesos.length + 1 > qtdeColMin ? pesos.length + 1 : qtdeColMin;
    let qtdeLinhas = idades.length + 2 > qtdeLinMin ? idades.length + 2 : qtdeLinMin;

    let matriz = new Array<Array<any>>();
    for (let i = 0; i < qtdeLinhas; i++) {
      matriz[i] = [];
      for (let j = 0; j < qtdeCols; j++) {
        this.prepararCelula(matriz, prod, i, j);
      }
    }

    prod.quantidades.forEach((q) => {
      let indexPeso = pesos.indexOf(q.pesoKg);
      let indexIdade = idades.indexOf(idades.filter((i) => i.idade == q.idade && i.tipoIdade == q.tipoIdade)[0]);
      matriz[indexIdade + 2][indexPeso + 1].valor = this.getQuantProdFormat(q.quantidade);
      matriz[indexIdade + 2][indexPeso + 1].idUnidadeMedida = q.idUnidadeMedida;
      matriz[0][indexPeso + 1].valor = this.getPesoFormat(q.pesoKg);
      matriz[indexIdade + 2][0].valor = q.idade;
      matriz[indexIdade + 2][0].tipoIdade = TipoIdade[q.tipoIdade];
    });

    for (let i = 0; i < qtdeLinhas; i++) {
      for (let j = 0; j < qtdeCols; j++) {
        this.habilitarProd(matriz, i, j);
      }
    }

    return matriz;
  }

  private getPesoFormat(peso: Number) {
    if (!peso) {
      return peso;
    }
    return String(peso).replace('.', ',') + ' kg';
  }

  private getQuantProdFormat(quant: Number) {
    if (quant == null) {
      return quant;
    }
    return String(quant).replace('.', ',');
  }

  private prepararCelula(matriz, prod, linha, coluna) {
    matriz[linha][coluna] = {
      valor: this.getValorMatriz(linha, coluna),
      classe: this.getClasseCssMatriz(linha, coluna),
      disabled: this.getDisabledInputMatriz(linha, coluna),
      selecionado: false,
      tipoIdade: TipoIdade.A,
      idUnidadeMedida: ID_UNIT_ML_DIA,
    };
  }

  private onChangeValueMatriz(objeto, linha, coluna) {
    for (let l = 2; l < this.matrizSel.length; l++) {
      for (let c = 1; c < this.matrizSel[0].length; c++) {
        if (linha == l || coluna == c) {
          this.habilitarProd(this.matrizSel, l, c);
        }
      }
    }
    this.atualizarMatrizSel(this.prodSel.idProduto);
  }

  private classQuantSemValor = ' quantSemValor';
  private classQuantDesabil = ' quantDesabilitado';

  private habilitarProd(matriz, linha, coluna) {
    if (linha < 2 || coluna == 0) {
      return;
    }

    let habilitado: boolean =
      this.isTemValorPositivo(matriz[0][coluna].valor) && this.isTemValorPositivo(matriz[linha][0].valor);
    let obj = matriz[linha][coluna];
    if (habilitado) {
      obj.classe = obj.classe.replace(/quantDesabilitado/gi, '');
      obj.disabled = false;
      if (obj.valor || obj.valor == 0) {
        obj.classe = obj.classe.replace(/quantSemValor/gi, '');
      } else {
        if (obj.classe.indexOf(this.classQuantSemValor) == -1) {
          obj.classe += this.classQuantSemValor;
        }
      }
    } else {
      if (obj.classe.indexOf(this.classQuantDesabil) == -1) {
        obj.classe += this.classQuantDesabil;
      }
      obj.classe = obj.classe.replace(/quantSemValor/gi, '');
      obj.disabled = true;
    }
  }

  private getValorMatriz(linha, coluna) {
    if (coluna == 0 && linha == 0) {
      return 'Peso até';
    }
    if (coluna == 0 && linha == 1) {
      return 'Idade até';
    }
    if (linha == 1) {
      return null;
    }
    //return linha + '-' + coluna;
    return null;
  }

  private classCelTituloPeso = 'categoria titulo-peso';
  private classCelTituloIdade = 'categoria titulo-idade';
  private classCelCategIdade = 'categoria idade';
  private classCelCategPeso = 'categoria peso';
  private classCelNada = 'nada';

  private getClasseCssMatriz(linha, coluna) {
    if (coluna == 0 && linha == 0) {
      return this.classCelTituloPeso;
    }
    if (coluna == 0 && linha == 1) {
      return this.classCelTituloIdade;
    }
    if (coluna > 0 && linha == 1) {
      return this.classCelNada;
    }
    if (coluna == 0) {
      return this.classCelCategIdade;
    }
    if (linha == 0) {
      return this.classCelCategPeso;
    }

    return '';
  }

  private getDisabledInputMatriz(linha, coluna) {
    if (coluna == 0 && (linha == 0 || linha == 1)) {
      return true;
    }
    if (coluna > 0 && linha == 1) {
      return true;
    }

    return false;
  }

  static classSelecionado = ' selecionado';

  private timerFocus: any;
  private matrizFocus(event, linha, coluna) {
    if (this.timerFocus) {
      clearTimeout(this.timerFocus);
    }
    let timer = setTimeout(() => {
      this.matrizFocusExec(event, linha, coluna);
    }, 30);
  }

  private matrizFocusExec(event, linha, coluna) {
    for (let i = 0; i < this.matrizSel[0].length; i++) {
      this.matrizSel[0][i].classe = this.matrizSel[0][i].classe.replace(TherapyForm.classSelecionado, '');
    }
    for (let i = 0; i < this.matrizSel.length; i++) {
      this.matrizSel[i][0].classe = this.matrizSel[i][0].classe.replace(TherapyForm.classSelecionado, '');
    }
    if (coluna > 0) {
      this.matrizSel[0][coluna].classe += TherapyForm.classSelecionado;
    } else {
      this.matrizSel[1][coluna].classe += TherapyForm.classSelecionado;
    }
    this.matrizSel[linha][0].classe += TherapyForm.classSelecionado;
    this.atualizarMatrizSel(this.prodSel.id);
  }

  private atualizarMatrizSel(idProduto) {
    let matriz = Object.assign(new Array<Array<any>>(), this.matrizSel);
    this.mapProdMatriz[idProduto] = matriz;
    this.matrizSel = matriz;
  }

  private timeoutMatrizKeyDown: any;
  private matrizKeyDown(event, linha, coluna) {
    if (this.timeoutMatrizKeyDown) {
      clearTimeout(this.timeoutMatrizKeyDown);
    }

    this.timeoutMatrizKeyDown = setTimeout(() => {
      this.matrizKeyDownExec(event, linha, coluna);
    }, 30);
  }

  private matrizKeyDownExec(event, linha, coluna) {
    if (event.keyCode == 37) {
      // esquerda
      coluna--;
    } else if (event.keyCode == 39) {
      // direita
      coluna++;
    } else if (event.keyCode == 40) {
      // baixo
      linha++;
      if (linha == 1) {
        linha++;
      }
    } else if (event.keyCode == 38) {
      // cima
      linha--;
      if (linha == 1) {
        linha--;
      }
    } else {
      return;
    }
    let ref = this.getNomeCel(linha, coluna);
    let elem: any = this.$refs[ref];
    if (elem && elem.length) {
      elem[0].focus();
    } else {
      if (linha >= this.matrizSel.length) {
        this.adicionarLinhaMatriz();
      }
      if (coluna >= this.matrizSel[0].length) {
        this.adicionarColunaMatriz();
      }
    }
  }

  private adicionarLinhaMatriz(): void {
    let linha = this.matrizSel.length;
    this.matrizSel[linha] = [[]];
    for (let i = 0; i < this.matrizSel[0].length; i++) {
      this.prepararCelula(this.matrizSel, this.prodsSelecionados[0], linha, i);
      this.habilitarProd(this.matrizSel, linha, i);
    }
    this.atualizarMatrizSel(this.prodSel.id);
  }

  private adicionarColunaMatriz(): void {
    let col = this.matrizSel[0].length;
    for (let i = 0; i < this.matrizSel.length; i++) {
      this.prepararCelula(this.matrizSel, this.prodsSelecionados[0], i, col);
      this.habilitarProd(this.matrizSel, i, col);
    }
    this.atualizarMatrizSel(this.prodSel.id);
  }

  private getNomeCel(linha, coluna) {
    return 'cel-' + this.prodSel.idProduto + '-' + linha + '-' + coluna;
  }

  public init(): void {
    if (!!this.id || this.loading) {
      return;
    }
    this.loading = true;
    this.error = false;
    this.addSubsc(
      service.getInitTherapy().subscribe(
        (result) => {
          result.nomeTerapia = this.dto.nomeTerapia;
          result.ativo = this.dto.ativo;
          this.processarDetalheDTOResult(result);
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      ),
    );
  }

  buscarTerapia() {
    if (!this.id) {
      return;
    }
    this.loading = true;
    this.error = false;
    this.addSubsc(
      service.getTherapy(this.id).subscribe(
        (result) => {
          this.processarDetalheDTOResult(result);
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      ),
    );
  }

  processarDetalheDTOResult(result: TerapiaDetalheDTO) {
    this.dto = result;

    if (!this.dto.produtos || !this.dto.produtos.length) {
      this.loading = false;
      return;
    }
    this.dto.produtos.splice(0, 0, this.gerarProdutoVolume(this.dto.volumes));
    this.dto.produtos.forEach((p) => {
      let matriz = this.gerarMatrizProduto(p);
      this.mapProdMatriz[p.idProduto as any] = matriz;
    });
    if (!this.id) {
      this.soProdEscolhidos = false;
    }
    this.onCheckProdEscolhidos();
    this.selecionarProduto(this.dto.produtos[0]);
    this.loading = false;
  }

  private gerarProdutoVolume(volumes: VolumeTerapiaDTO[]): any {
    let volProd: any = {};
    volProd.nomeProduto = 'Volume Final';
    volProd.volume = true;
    volProd.idProduto = -1;
    volProd.quantidades = volumes;
    return volProd;
  }

  private selecionarProduto(prod): void {
    this.prodsSelecionados = [];
    this.prodsSelecionados.push(prod);
    this.prodSel = prod;
    this.loadingProd = true;
    this.matrizSel = this.mapProdMatriz[prod.idProduto];
    setTimeout(() => {
      this.loadingProd = false;
    }, 10);
  }

  public saveItem(): void {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando ...');

    let parm: TerapiaParmDTO = new TerapiaParmDTO();
    parm.idTerapia = this.dto.id;
    parm.codTerapia = this.dto.codTerapia;
    parm.nomeTerapia = this.dto.nomeTerapia;
    parm.ativo = this.dto.ativo;
    parm.enteralObjetivoCalorico = this.dto.enteralObjetivoCalorico;
    parm.enteralFatorTermogenese = this.dto.enteralFatorTermogenese;
    parm.enteralFatorSuspensao = this.dto.enteralFatorSuspensao;
    parm.produtos = new Array();
    parm.volumes = new Array();

    for (let p = 0; p < this.dto.produtos.length; p++) {
      let prod = this.dto.produtos[p];
      if (this.isProdVolume(prod)) {
        let matriz: any = this.mapProdMatriz[prod.idProduto as any];
        for (let l = 2; l < matriz.length; l++) {
          for (let c = 1; c < matriz[0].length; c++) {
            let qtde = this.getQuantDTOCel(matriz, l, c, true, true);
            if (qtde) {
              parm.volumes.push(qtde as VolumeTerapiaParmDTO);
            }
          }
        }
      } else {
        let prodParm: ProdutoTerapiaParmDTO = new ProdutoTerapiaParmDTO();
        prodParm.quantidades = new Array();
        prodParm.idProduto = prod.idProduto;
        prodParm.idUnidadeMedida = prod.idUnidadeMedida;
        let matriz: any = this.mapProdMatriz[prodParm.idProduto as any];
        for (let l = 2; l < matriz.length; l++) {
          for (let c = 1; c < matriz[0].length; c++) {
            let qtde = this.getQuantDTOCel(matriz, l, c, true, false);
            if (qtde) {
              prodParm.quantidades.push(qtde);
            }
          }
        }
        if (prodParm.quantidades.length) {
          parm.produtos.push(prodParm);
        }
      }
    }

    this.addSubsc(
      service.saveTherapy(parm).subscribe(
        (result) => {
          this.resetForm();
          this.loader.stop();
          this.$emit('save');
        },
        (error) => {
          this.loader.stop();
          this.toast.show(error.data.message.replace(/\n/g, '</br>'), 'error', true, 8000);
        },
      ),
    );
  }

  private getQuantDTOCel(
    matriz,
    linha,
    coluna,
    precisaValor,
    volume: boolean,
  ): IdadePesoQtdeTerapiaParmDTO | VolumeTerapiaParmDTO {
    let valor = matriz[linha][coluna].valor;
    if (precisaValor && !valor) {
      return null;
    }

    let objPeso = matriz[0][coluna];
    let objIdade = matriz[linha][0];

    let peso = objPeso.valor;
    let idade = objIdade.valor;
    let tipoIdade = objIdade.tipoIdade;

    if (!this.isTemValorPositivo(peso) || !this.isTemValorPositivo(idade) || tipoIdade == null) {
      return null;
    }

    let qtde;
    if (volume) {
      qtde = new VolumeTerapiaParmDTO();
      qtde.idUnidadeMedida = matriz[linha][coluna].idUnidadeMedida;
    } else {
      qtde = new IdadePesoQtdeTerapiaParmDTO();
    }
    qtde.pesoKg = this.getValorSemMask(String(peso), this.maskPeso);
    if (!qtde.pesoKg) qtde.pesoKg = peso;
    qtde.idade = this.getValorSemMask(String(idade), this.maskProd);
    if (!qtde.idade) qtde.idade = idade;
    qtde.tipoIdade = TipoIdade[tipoIdade];
    qtde.quantidade = this.getValorSemMask(String(valor), this.maskProd);
    if (!qtde.quantidade && qtde.quantidade != 0) qtde.quantidade = valor;

    return qtde;
  }

  public resetForm(): void {
    this.dto = new TerapiaDetalheDTO();
    this.matrizSel = null;
    this.prodsSelecionados = [];
    this.prodSel = null;
    this.mapProdMatriz = new Map<Number, Array<Array<any>>>();
    this.$refs.form.resetValidation();
  }

  private closeAction() {
    this.resetForm();
    this.$emit('close');
  }

  public closeForm(): void {
    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      this.closeAction,
    );
  }

  private isTemValorPositivo(valor): boolean {
    if (!valor) {
      valor = 0;
    }
    return Number(new String(valor).replace(/[^0-9]/g, '')) > 0;
  }
}
